import React, { Suspense } from "react";
import { useParams } from "react-router-dom";
import { PROJECT_PAGE_REGISTRY } from "./projects/registry";
import GenericProjectDetail from "./ProjectDetail";

export default function ProjectDetailRouter() {
  const { id } = useParams();
  const CustomComp = PROJECT_PAGE_REGISTRY[id];

  if (!CustomComp) {
    return <GenericProjectDetail />;
  }

  return (
    <Suspense fallback={<div className="p-8">Loading…</div>}>
      <CustomComp />
    </Suspense>
  );
}
